<div class="je-modal-container je-dialog">
    <h2 mat-dialog-title>{{title}}</h2>
    <mat-dialog-content class="mat-typography">
      {{body}}
      <div>{{footer}}</div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-raised-button [mat-dialog-close]="true">Ok</button>
    </mat-dialog-actions>
  </div>